<script setup lang="ts">
import AuthLayout from "@/layouts/auth/AuthSimpleLayout.vue"

defineProps<{
  title?: string
  description?: string
  logoHref?: string
}>()
</script>

<template>
  <AuthLayout :title="title" :description="description" :logo-href="logoHref">
    <slot />
  </AuthLayout>
</template>
